<div class="modal-header">
  <h4 id="unapprove-item-modal" class="modal-title">
    {{ "Unapprove" | translate }}: {{ equipmentItemService.getName$(equipmentItem) | async }}
  </h4>

  <button (click)="cancel()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p>{{ "This operation will let equipment moderators review this item again." | translate }}</p>
</div>

<div class="modal-footer">
  <button (click)="cancel()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>

  <button [class.loading]="loadingService.loading$ | async" (click)="unapprove()" class="btn btn-danger" type="button">
    {{ "Unapprove" | translate }}
  </button>
</div>
